import { formOperatorId } from '../constants';

const equalStrategy = ({ condition, value }) => ({
  key: condition.fieldId,
  value: condition.value === value,
});

const strategyMap = {
  [formOperatorId.EQUAL]: equalStrategy,
};

const conditionStrategy = ({ condition, value }) => {
  const strategy = strategyMap[condition?.operatorId];
  if (!strategy) return;
  return strategy({ condition, value });
};

export default conditionStrategy;
